import { deserializeValue } from './deserialize-value';
/**
 * Deserializes a stringified value back to it's original type.
 */
export const parse = (value) => {
    if (!value)
        return value; // null/undefined
    let parsedValue;
    try {
        parsedValue = JSON.parse(value);
    }
    catch (error) {
        // If we can't parse, it's probably because it isn't an object
        parsedValue = value;
    }
    return deserializeValue(parsedValue);
};
//# sourceMappingURL=parse.js.map